'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.core.a11y.cb-a11y', []);

_module.directive('cbA11y', cbA11yDirective);

exports.default = _module;


function cbA11yDirective() {
    return {
        controller: ['DyslexieService', 'ContrastService', function controller(DyslexieService, ContrastService) {
            var vm = this;

            vm.isDyslexieEnabled = DyslexieService.get();
            vm.isContrastEnabled = ContrastService.get();
        }],
        controllerAs: 'a11y',
        link: function link(scope, element, attrs, ctrl, transclude) {
            transclude(scope, function (clone) {
                element.after(clone);
            });
        },
        priority: 1, // without this, ng-class on the element won't work
        transclude: 'element'
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/a11y/cb-a11y.directive.js
// module id = 765
// module chunks = 0